<template>
  <aside class="main-sidebar sidebar-dark-primary elevation-4" style="height: 100vh;">
    <!-- Brand Logo -->
    <a href="#" class="brand-link">
      <img :src="imgSrcUrl" alt="Ultron" class="brand-image img-circle elevation-3" style="opacity: .8">
      <span class="brand-text font-weight-light text-md">{{TranslateText(siteName)}}</span>
    </a>

    <!-- Sidebar -->
    <div class="sidebar">
      <!-- Sidebar Menu -->
      <nav class="mt-2">
        <user-navigation />
      </nav>
      <!-- /.sidebar-menu -->
    </div>
    <!-- /.sidebar -->
  </aside>
</template>

<script>
  import UserNavigation from './UserNavigation.vue';
  import { mapGetters } from 'vuex';

  export default {
    components: {
      UserNavigation
    },
    computed: {
      tenant: function () {
        return this.$store.getters.GetTenant();
      },
      imgSrcUrl: function () {
        let tenant = this.GetTenant();

        return tenant && tenant.smallLogo || '/static/assets/img/logo.png';
      },
      siteName: function () {
        let tenant = this.GetTenant();
        return tenant && tenant.name || 'Ultron Techniques';
      },
      ...mapGetters(['GetTenant','TranslateText'
      ]),
    },
    mounted: function () {
     
    }
  }
</script>

<style>
  .is-active-route {
    background-color: #ccbc63;
    border-radius: 5px;
  }



  .sidebar-mini.sidebar-collapse .main-sidebar, .sidebar-mini.sidebar-collapse .main-sidebar::after {
    background-color: #1f2d3d !important;
  }

    /*  .sidebar-mini.sidebar-collapse .nav-sidebar .nav-link p {
    width: auto;
    white-space: normal;
  }*/

    .sidebar-mini.sidebar-collapse .main-sidebar:not(.sidebar-no-expand).sidebar-focused,
    .sidebar-mini.sidebar-collapse .main-sidebar:not(.sidebar-no-expand):hover {
      width: 380px !important;
    }

  [class*="sidebar-dark-"] .nav-sidebar > .nav-item.menu-open > .nav-link, [class*="sidebar-dark-"] .nav-sidebar > .nav-item:hover > .nav-link, [class*="sidebar-dark-"] .nav-sidebar > .nav-item > .nav-link:focus {
    width: 380px !important;
  }

  [class*="sidebar-dark-"] .nav-treeview > .nav-item > .nav-link {
    width: 380px !important;
  }

  .sidebar-mini.sidebar-collapse .main-sidebar:hover .brand-link, .sidebar-mini.sidebar-collapse .main-sidebar.sidebar-focused .brand-link {
    width: 380px !important;
  }

  /* Menu wording is never cut off. In the hover / focus-expanded desktop sidebar the
     longest report names are wider than the 380px panel, so let labels wrap onto a
     second line instead of running past the edge (AdminLTE forces nowrap + width 0). */
  .sidebar-mini.sidebar-collapse .main-sidebar:hover .nav-sidebar .nav-link p,
  .sidebar-mini.sidebar-collapse .main-sidebar.sidebar-focused .nav-sidebar .nav-link p {
    width: auto;
    white-space: normal;
  }

  /* Off-canvas sidebar on tablet / mobile (below 992px) is only 250px wide: drop the fixed
     380px link widths meant for the desktop hover state and let labels wrap inside it. */
  @media (max-width: 991.98px) {
    /* selectors outrank the 380px rules above, which are up to five classes deep */
    .wrapper .main-sidebar .sidebar .nav-sidebar .nav-item .nav-link {
      width: auto !important;
    }

    /* the brand link is position: fixed in this layout, so it needs the sidebar width
       (250px) explicitly; auto would shrink it to the logo and name */
    .wrapper .main-sidebar .brand-link.brand-link {
      width: 250px !important;
    }

    .main-sidebar .nav-sidebar .nav-link p {
      white-space: normal;
    }

    .main-sidebar .sidebar {
      overflow-x: hidden;
    }
  }


  /*
  .sidebar-collapse.sidebar-mini .main-sidebar.sidebar-focused .nav-link, .sidebar-collapse.sidebar-mini .main-sidebar:hover .nav-link, .sidebar-collapse.sidebar-mini-md .main-sidebar.sidebar-focused .nav-link, .sidebar-collapse.sidebar-mini-md .main-sidebar:hover .nav-link, .sidebar-collapse.sidebar-mini-xs .main-sidebar.sidebar-focused .nav-link, .sidebar-collapse.sidebar-mini-xs .main-sidebar:hover .nav-link {
    width: 20rem !important;
  }

  .sidebar-collapse.sidebar-mini .main-sidebar .nav-sidebar .nav-link, .sidebar-collapse.sidebar-mini-md .main-sidebar .nav-sidebar .nav-link, .sidebar-collapse.sidebar-mini-xs .main-sidebar .nav-sidebar .nav-link {
    width: 20rem !important;
  }*/

</style>



// WEBPACK FOOTER //
// src/components/SideBar.vue